"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "bg-white p-5 mb-4"
};
const _hoisted_2 = {
    key: 0,
    class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5"
};
const _hoisted_3 = { class: "w-60 text-base pt-3" };
const _hoisted_4 = { class: "filters justify-between lg:items-end print:hidden" };
const _hoisted_5 = { class: "flex flex-col md:flex-row gap-5" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = {
    key: 0,
    class: "flex flex-col md:flex-row gap-5 text-sm text-right py-2 uppercase font-bold pb-3 text-green"
};
const _hoisted_8 = { class: "flex flex-col md:flex-row gap-4 p-3" };
const _hoisted_9 = { class: "uppercase w-full font-bold text-xl pb-3" };
const _hoisted_10 = { class: "overflow-y-scroll max-h-[300px] border-1 border-gray" };
const _hoisted_11 = {
    id: "my-invoices-table",
    class: "table-auto w-full"
};
const _hoisted_12 = { class: "border-b-1 border-gray" };
const _hoisted_13 = { class: "p-2 text-left" };
const _hoisted_14 = { class: "p-2 text-left" };
const _hoisted_15 = { class: "p-2 text-left" };
const _hoisted_16 = { class: "p-2 text-left" };
const _hoisted_17 = { class: "p-2 text-center" };
const _hoisted_18 = { class: "border-b-1 border-gray" };
const _hoisted_19 = { class: "p-2 text-left" };
const _hoisted_20 = { class: "p-2 text-left" };
const _hoisted_21 = { class: "p-2 text-left" };
const _hoisted_22 = { class: "p-2 text-left" };
const _hoisted_23 = { class: "p-2 text-center" };
const _hoisted_24 = { class: "p-2 text-left" };
const _hoisted_25 = ["onClick"];
const _hoisted_26 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_27 = { key: 1 };
const _hoisted_28 = { colspan: "5" };
const _hoisted_29 = { class: "uppercase font-bold text-xl border-b-1 border-gray pb-3 pt-3 mt-4" };
const _hoisted_30 = { class: "flex flex-col md:flex-row border-b-1 border-gray" };
const _hoisted_31 = { class: "flex items-start w-full md:w-1/2" };
const _hoisted_32 = { class: "w-56 text-base py-5" };
const _hoisted_33 = { class: "grow py-5 font-bold text-right md:w-1/2" };
const _hoisted_34 = { key: 0 };
const _hoisted_35 = { class: "flex items-start w-full md:w-1/2 md:pl-3.5" };
const _hoisted_36 = { class: "w-56 text-base py-5" };
const _hoisted_37 = {
    key: 0,
    class: "grow py-5 font-bold text-right"
};
const _hoisted_38 = { class: "flex flex-col md:flex-row" };
const _hoisted_39 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_40 = { class: "w-56 text-base pt-3" };
const _hoisted_41 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_42 = { class: "w-56 text-base pt-3" };
const _hoisted_43 = { class: "flex flex-col md:flex-row" };
const _hoisted_44 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_45 = { class: "w-56 text-base pt-3" };
const _hoisted_46 = { class: "flex items-start w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_47 = { class: "w-56 text-base pt-3" };
const _hoisted_48 = { class: "flex flex-col md:flex-row" };
const _hoisted_49 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5" };
const _hoisted_50 = { class: "w-full text-base pt-3" };
const _hoisted_51 = { class: "inline-flex items-start mr-2 pt-3" };
const _hoisted_52 = { class: "flex items-center" };
const _hoisted_53 = { class: "inline font-bold uppercase text-base mr-2" };
const _hoisted_54 = { class: "inline font-bold uppercase text-base" };
const _hoisted_55 = { class: "flex items-centerw-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_56 = { class: "w-56 text-base pt-3" };
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const vue_3 = require("vue");
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const MainUseAreaEnum_1 = require("../../models/guaranteeProductReturn/MainUseAreaEnum");
const vehicleTypeStore_1 = require("../../stores/vehicleType/vehicleTypeStore");
const TyreSearcher_vue_1 = __importDefault(require("./TyreSearcher.vue"));
const i18n_1 = require("../../common/i18n");
const securityStore_1 = require("../../stores/security/securityStore");
const shop_1 = require("../../common/utils/shop");
const axaptaCustomerProductReturnStore_1 = require("../../stores/axaptaCustomerProductReturn/axaptaCustomerProductReturnStore");
const vue_router_1 = require("vue-router");
const PermissionEnum_1 = require("../../models/permission/PermissionEnum");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const GuaranteeTypeEnum_1 = require("../../models/guaranteeProductReturn/GuaranteeTypeEnum");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductDataForm',
    props: {
        guaranteeProductReturnCreateRequest: {
            type: Object,
        },
    },
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g;
        const props = __props;
        const router = (0, vue_router_1.useRouter)();
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const vehicleTypeStore = (0, vehicleTypeStore_1.useVehicleTypeStore)();
        const axaptaCustomerProductReturnStore = (0, axaptaCustomerProductReturnStore_1.useAxaptaCustomerProductReturnStore)();
        const filterInvoiceId = (0, vue_3.ref)("");
        const filterProductId = (0, vue_3.ref)(null);
        const startDateYear = (0, vue_3.ref)(null);
        const axaptaCustomerProductReturnsItemList = (0, vue_3.ref)([]);
        const defaultFilterStartDate = (0, vue_3.computed)(() => {
            let halfYearBeforeToday = new Date();
            halfYearBeforeToday.setMonth(halfYearBeforeToday.getMonth() - 24);
            return (0, shop_1.formatDate)(halfYearBeforeToday);
        });
        const defaultFilterEndDate = (0, vue_3.computed)(() => {
            return (0, shop_1.formatDate)(new Date());
        });
        const currentUser = (0, vue_3.computed)(() => {
            return securityStore.authenticatedUser;
        });
        const getYears = (0, vue_3.computed)(() => {
            const currentYear = new Date().getFullYear();
            const dropdownItems = [];
            for (let i = 0; i < 10; i++) {
                const year = (currentYear - i).toString();
                dropdownItems.push(new DropdownInputItem_1.default(year, year));
            }
            return dropdownItems;
        });
        const getMonths = (0, vue_3.ref)([
            new DropdownInputItem_1.default('1', `${(0, i18n_1.trans)('january', 'January', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('2', `${(0, i18n_1.trans)('february', 'February', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('3', `${(0, i18n_1.trans)('march', 'March', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('4', `${(0, i18n_1.trans)('april', 'April', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('5', `${(0, i18n_1.trans)('may', 'May', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('6', `${(0, i18n_1.trans)('june', 'June', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('7', `${(0, i18n_1.trans)('july', 'July', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('8', `${(0, i18n_1.trans)('august', 'August', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('9', `${(0, i18n_1.trans)('september', 'September', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('10', `${(0, i18n_1.trans)('october', 'October', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('11', `${(0, i18n_1.trans)('november', 'November', 'guarantee_product_return')}`),
            new DropdownInputItem_1.default('12', `${(0, i18n_1.trans)('december', 'December', 'guarantee_product_return')}`),
        ]);
        const filter = (0, vue_3.ref)({
            startDate: defaultFilterStartDate.value,
            endDate: defaultFilterEndDate.value,
            itemId: null,
        });
        const mainUseAreOptions = (0, vue_3.ref)([
            new Option_1.default(MainUseAreaEnum_1.MainUseAreaEnum.PUBLIC_ROAD, (_a = (0, i18n_1.trans)("main_use_area_public_road", "Public Road", "guarantee_product_return")) !== null && _a !== void 0 ? _a : "Public Road", false),
            new Option_1.default(MainUseAreaEnum_1.MainUseAreaEnum.BUILDING_AREA, (_b = (0, i18n_1.trans)("main_use_area_building_area", "Building Area", "guarantee_product_return")) !== null && _b !== void 0 ? _b : "Public Road", false),
            new Option_1.default(MainUseAreaEnum_1.MainUseAreaEnum.AGRICULTURAL_AREA, (_c = (0, i18n_1.trans)("main_use_area_agricultural_area", "Agricultural Area", "guarantee_product_return")) !== null && _c !== void 0 ? _c : "Public Road", false),
            new Option_1.default(MainUseAreaEnum_1.MainUseAreaEnum.SANDY_ROAD, (_d = (0, i18n_1.trans)("main_use_area_sandy_road", "Sandy Road", "guarantee_product_return")) !== null && _d !== void 0 ? _d : "Public Road", false),
            new Option_1.default(MainUseAreaEnum_1.MainUseAreaEnum.STONED_ROAD, (_e = (0, i18n_1.trans)("main_use_area_stoned_road", "Stoned Road", "guarantee_product_return")) !== null && _e !== void 0 ? _e : "Public Road", false),
            new Option_1.default(MainUseAreaEnum_1.MainUseAreaEnum.FOREST_AREA, (_f = (0, i18n_1.trans)("main_use_area_forest_area", "Forest Area", "guarantee_product_return")) !== null && _f !== void 0 ? _f : "Public Road", false),
            new Option_1.default(MainUseAreaEnum_1.MainUseAreaEnum.OTHER, (_g = (0, i18n_1.trans)("main_use_area_other", "Other", "guarantee_product_return")) !== null && _g !== void 0 ? _g : "Public Road", false),
        ]);
        const submittedProduct = (0, vue_3.ref)(null);
        const selectInvoiceItem = (item, event) => {
            var _a;
            let target = event.currentTarget;
            if (!(target instanceof HTMLElement)) {
                return;
            }
            (_a = target.parentElement.parentElement.parentNode) === null || _a === void 0 ? void 0 : _a.querySelectorAll(".selected-row").forEach((targetItem) => {
                targetItem.classList.remove("bg-orange", "selected-row");
            });
            target.closest("tr").classList.add("bg-orange", "selected-row");
            submittedProduct.value = item;
            props.guaranteeProductReturnCreateRequest.purchaseDate = (0, shop_1.formatDate)(new Date(item.date));
            props.guaranteeProductReturnCreateRequest.customerInvoiceId = item.invoiceId;
            props.guaranteeProductReturnCreateRequest.product = "/api/products/" + item.productId;
            return true;
        };
        const clearTable = () => {
            document.querySelectorAll('#my-invoices-table tbody .selected-row').forEach((item) => {
                item.classList.remove("bg-orange", "selected-row");
            });
        };
        const getInvoices = async () => {
            var _a, _b;
            axaptaCustomerProductReturnStore.axaptaCustomerProductReturns = [];
            axaptaCustomerProductReturnsItemList.value = [];
            submittedProduct.value = null;
            var year = parseInt(startDateYear.value, 10);
            if (props.guaranteeProductReturnCreateRequest.filterpid) {
                filter.value.itemId = (_a = props.guaranteeProductReturnCreateRequest) === null || _a === void 0 ? void 0 : _a.filterpid;
            }
            else {
                filter.value.itemId = null;
            }
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth() + 1;
            const maxMonth = (year < currentYear) ? 12 : currentMonth;
            for (let month = 1; month <= maxMonth; month++) {
                var firstDay = new Date(year, month - 1, 2).toISOString().slice(0, 10);
                var lastDay = new Date(year, month, 1).toISOString().slice(0, 10);
                filter.value.startDate = firstDay;
                filter.value.endDate = lastDay;
                await axaptaCustomerProductReturnStore
                    .getCustomerProductReturns(router, filter.value, securityStore.authenticatedUser.customer.id).then(() => {
                    axaptaCustomerProductReturnsItemList.value = axaptaCustomerProductReturnsItemList.value.concat(axaptaCustomerProductReturnStore.axaptaCustomerProductReturns);
                });
                if (((_b = props.guaranteeProductReturnCreateRequest) === null || _b === void 0 ? void 0 : _b.guaranteeType) == (0, GuaranteeTypeEnum_1.getGuaranteeValue)(GuaranteeTypeEnum_1.GuaranteeTypeEnum.NOKIAN_GUARANTEE_PLUS)) {
                    axaptaCustomerProductReturnsItemList.value.forEach(item => {
                        if (item.productName.toLowerCase().includes('nokian')) {
                            axaptaCustomerProductReturnStore.axaptaCustomerProductReturns.push(item);
                            // ebben az esetben hozzá kell adni a megjelenítendő listához az itemet.
                        }
                    });
                }
                else {
                    axaptaCustomerProductReturnStore.axaptaCustomerProductReturns = axaptaCustomerProductReturnsItemList.value;
                }
            }
        };
        const filterProductList = () => {
            var _a;
            if ((_a = props.guaranteeProductReturnCreateRequest) === null || _a === void 0 ? void 0 : _a.filterpid) {
                return axaptaCustomerProductReturnStore.axaptaCustomerProductReturns =
                    axaptaCustomerProductReturnStore.axaptaCustomerProductReturns.filter((obj) => {
                        var _a;
                        return obj.productId === ((_a = props.guaranteeProductReturnCreateRequest) === null || _a === void 0 ? void 0 : _a.filterpid);
                    });
            }
            else if (filterProductId.value) {
                return axaptaCustomerProductReturnStore.axaptaCustomerProductReturns =
                    axaptaCustomerProductReturnStore.axaptaCustomerProductReturns.filter((obj) => {
                        return obj.productId == filterProductId.value;
                    });
            }
            if (filterInvoiceId.value) {
                return axaptaCustomerProductReturnStore.axaptaCustomerProductReturns =
                    axaptaCustomerProductReturnStore.axaptaCustomerProductReturns.filter((obj) => {
                        return obj.invoiceId === filterInvoiceId.value;
                    });
            }
            if (!axaptaCustomerProductReturnStore.axaptaCustomerProductReturns.length) {
                submittedProduct.value = null;
            }
            return (axaptaCustomerProductReturnStore.axaptaCustomerProductReturns =
                axaptaCustomerProductReturnsItemList.value);
        };
        const guaranteeTypeOptions = (0, vue_3.ref)([
            new Option_1.default((0, GuaranteeTypeEnum_1.getGuaranteeValue)(GuaranteeTypeEnum_1.GuaranteeTypeEnum.CENTRAL_PERMISSION), (0, GuaranteeTypeEnum_1.getGuaranteeValue)(GuaranteeTypeEnum_1.GuaranteeTypeEnum.CENTRAL_PERMISSION), false),
            new Option_1.default((0, GuaranteeTypeEnum_1.getGuaranteeValue)(GuaranteeTypeEnum_1.GuaranteeTypeEnum.NOKIAN_GUARANTEE_PLUS), (0, GuaranteeTypeEnum_1.getGuaranteeValue)(GuaranteeTypeEnum_1.GuaranteeTypeEnum.NOKIAN_GUARANTEE_PLUS), false),
        ]);
        const needGuaranteeTypeForm = (0, vue_3.computed)(() => {
            var _a;
            if (props.guaranteeProductReturnCreateRequest !== undefined) {
                // Ha NAD partner a vevő, akkor ő állítja be a garancia típust
                if ((_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CustomerPermissionEnum.NAD_PARTNER)) {
                    props.guaranteeProductReturnCreateRequest.guaranteeType = "";
                    return true;
                }
            }
            return false;
        });
        const isGetInvoiceButtonValid = (0, vue_3.computed)(() => {
            var _a, _b;
            // Ha NAD partner: kötelező kiválasztania egy típust, és az évszámot, ekkor lesz aktív a 'Get invoices' gomb
            if ((_a = currentUser.value) === null || _a === void 0 ? void 0 : _a.hasPermission(PermissionEnum_1.CustomerPermissionEnum.NAD_PARTNER)) {
                if (((_b = props.guaranteeProductReturnCreateRequest) === null || _b === void 0 ? void 0 : _b.guaranteeType) != '' && startDateYear.value) {
                    return true;
                }
                return false;
            }
            // Ha nem NAD partner: csak az évszám kötelező az aktiváláshoz
            if (startDateYear.value) {
                return true;
            }
            return false;
        });
        (0, vue_3.watch)(() => { var _a; return (_a = props.guaranteeProductReturnCreateRequest) === null || _a === void 0 ? void 0 : _a.guaranteeType; }, () => {
            axaptaCustomerProductReturnStore.axaptaCustomerProductReturns = [];
            submittedProduct.value = '';
            props.guaranteeProductReturnCreateRequest.product = '';
        });
        (0, vue_3.onMounted)(() => {
            if (props.guaranteeProductReturnCreateRequest !== undefined) {
                // Automatikusan "központi engedéllyel" típust állítsunk be
                props.guaranteeProductReturnCreateRequest.guaranteeType = (0, GuaranteeTypeEnum_1.getGuaranteeValue)(GuaranteeTypeEnum_1.GuaranteeTypeEnum.CENTRAL_PERMISSION);
            }
        });
        return (_ctx, _cache) => {
            var _a, _b, _c;
            return (__props.guaranteeProductReturnCreateRequest !== undefined)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    ((0, vue_2.unref)(needGuaranteeTypeForm))
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                            (0, vue_2.createElementVNode)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("choose_guarantee_type", "Choose guarantee type", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(SelectInput_vue_1.default, {
                                modelValue: __props.guaranteeProductReturnCreateRequest.guaranteeType,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((__props.guaranteeProductReturnCreateRequest.guaranteeType) = $event)),
                                "placeholder-enable": true,
                                placeholder: "",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isGuaranteeTypeValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('guarantee_type_required', 'Guarantee type required', 'guarantee_product_return'),
                                class: "!flex-row items-center !w-fit !grow",
                                options: guaranteeTypeOptions.value
                            }, null, 8, ["modelValue", "valid", "invalid-message", "options"])
                        ]))
                        : (0, vue_2.createCommentVNode)("", true),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                                modelValue: startDateYear.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((startDateYear).value = $event)),
                                placeholder: (0, vue_2.unref)(i18n_1.trans)('year', 'Year', 'guarantee_product_return'),
                                items: (0, vue_2.unref)(getYears),
                                "disable-deselect": ""
                            }, null, 8, ["modelValue", "placeholder", "items"]),
                            (0, vue_2.createVNode)(TyreSearcher_vue_1.default, {
                                "guarantee-product-return-create-request": __props.guaranteeProductReturnCreateRequest,
                                clearTable: clearTable
                            }, null, 8, ["guarantee-product-return-create-request"]),
                            (0, vue_2.createElementVNode)("button", {
                                type: "button",
                                class: "btn btn-rounded btn-primary h-[48px]",
                                disabled: !(0, vue_2.unref)(isGetInvoiceButtonValid),
                                onClick: _cache[2] || (_cache[2] = ($event) => (getInvoices()))
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("get_invoices", "Get invoices", "guarantee_product_return")), 9, _hoisted_6)
                        ]),
                        (((_a = props.guaranteeProductReturnCreateRequest) === null || _a === void 0 ? void 0 : _a.filterpid) !== null)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_7, (0, vue_2.toDisplayString)((_b = props.guaranteeProductReturnCreateRequest) === null || _b === void 0 ? void 0 : _b.filterpid) + " - " + (0, vue_2.toDisplayString)((_c = props.guaranteeProductReturnCreateRequest) === null || _c === void 0 ? void 0 : _c.filterpname), 1))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("my_invoices", "My invoices", "guarantee_product_return")), 1),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('invoice_id_placeholder', 'Invoice ID', 'guarantee_product_return'),
                            modelValue: filterInvoiceId.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((filterInvoiceId).value = $event)),
                            class: "order-filter-input",
                            type: "text",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('product_id_placeholder', 'Product ID', 'guarantee_product_return'),
                            modelValue: filterProductId.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((filterProductId).value = $event)),
                            class: "order-filter-input",
                            type: "text",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "modelValue"]),
                        (0, vue_2.createElementVNode)("button", {
                            type: "button",
                            class: "btn btn-block btn-rounded btn-primary h-[48px]",
                            onClick: _cache[5] || (_cache[5] = ($event) => (filterProductList()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("filter", "Filter", "guarantee_product_return")), 1)
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_10, [
                        (0, vue_2.createElementVNode)("table", _hoisted_11, [
                            (0, vue_2.createElementVNode)("thead", _hoisted_12, [
                                (0, vue_2.createElementVNode)("tr", null, [
                                    (0, vue_2.createElementVNode)("th", _hoisted_13, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('invoice_date', 'Invoice date', 'guarantee_product_return')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('invoice_id', 'Invoice ID', 'guarantee_product_return')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('product_id', 'Product ID', 'guarantee_product_return')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('product_name', 'Product Name', 'guarantee_product_return')), 1),
                                    (0, vue_2.createElementVNode)("th", _hoisted_17, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('product_creditable_quantity', 'Creditable quantity', 'guarantee_product_return')), 1)
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("tbody", null, [
                                ((0, vue_2.unref)(axaptaCustomerProductReturnStore).axaptaCustomerProductReturns.length)
                                    ? ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, (0, vue_2.renderList)((0, vue_2.unref)(axaptaCustomerProductReturnStore).axaptaCustomerProductReturns, (invoice) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_18, [
                                            (0, vue_2.createElementVNode)("th", _hoisted_19, (0, vue_2.toDisplayString)(invoice.date), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_20, (0, vue_2.toDisplayString)(invoice.invoiceId), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_21, (0, vue_2.toDisplayString)(invoice.productId), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_22, (0, vue_2.toDisplayString)(invoice.productName), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_23, (0, vue_2.toDisplayString)(invoice.creditableQuantity), 1),
                                            (0, vue_2.createElementVNode)("th", _hoisted_24, [
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn btn-rounded btn-primary btn-link",
                                                    onClick: ($event) => (selectInvoiceItem(invoice, $event))
                                                }, [
                                                    _hoisted_26,
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("add_customer_product_item", "Select", "guarantee_product_return")), 1)
                                                ], 8, _hoisted_25)
                                            ])
                                        ]));
                                    }), 256))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("tr", _hoisted_27, [
                                        (0, vue_2.createElementVNode)("th", _hoisted_28, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('no_resul', 'No result', 'guarantee_product_return')), 1)
                                    ]))
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("product_data", "Product Data", "guarantee_product_return")), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_30, [
                        (0, vue_2.createElementVNode)("div", _hoisted_31, [
                            (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("product_id", "Product ID", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                (submittedProduct.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_34, (0, vue_2.toDisplayString)(submittedProduct.value.productId), 1))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_35, [
                            (0, vue_2.createElementVNode)("div", _hoisted_36, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("product_name", "Product Name", "guarantee_product_return")), 1),
                            (submittedProduct.value)
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_37, (0, vue_2.toDisplayString)(submittedProduct.value.productName), 1))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_38, [
                        (0, vue_2.createElementVNode)("div", _hoisted_39, [
                            (0, vue_2.createElementVNode)("div", _hoisted_40, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("residual_profile_depth", "Residual Profile Depth", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isResidualProfileDepthValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('residual_profile_depth_required', 'Residual profile depth required', 'guarantee_product_return'),
                                type: "number",
                                step: 0.01,
                                required: "",
                                modelValue: __props.guaranteeProductReturnCreateRequest.residualProfileDepth,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((__props.guaranteeProductReturnCreateRequest.residualProfileDepth) = $event))
                            }, null, 8, ["valid", "invalid-message", "step", "modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                            (0, vue_2.createElementVNode)("div", _hoisted_42, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("operating_pressure", "Operating pressure", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isOperatingPressureValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('operating_pressure_required', 'Operting pressure required', 'guarantee_product_return'),
                                type: "number",
                                step: 0.01,
                                required: "",
                                modelValue: __props.guaranteeProductReturnCreateRequest.operatingPressure,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((__props.guaranteeProductReturnCreateRequest.operatingPressure) = $event))
                            }, null, 8, ["valid", "invalid-message", "step", "modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_43, [
                        (0, vue_2.createElementVNode)("div", _hoisted_44, [
                            (0, vue_2.createElementVNode)("div", _hoisted_45, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("dot_number", "DOT number", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isDOTNumberValid(),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('dot_number_required', 'DOT number required', 'guarantee_product_return'),
                                required: "",
                                modelValue: __props.guaranteeProductReturnCreateRequest.dotNumber,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((__props.guaranteeProductReturnCreateRequest.dotNumber) = $event))
                            }, null, 8, ["valid", "invalid-message", "modelValue"])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_46, [
                            (0, vue_2.createElementVNode)("div", _hoisted_47, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("production_number", "Production number", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                class: "!w-fit !grow",
                                border: "",
                                modelValue: __props.guaranteeProductReturnCreateRequest.productionNumber,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((__props.guaranteeProductReturnCreateRequest.productionNumber) = $event))
                            }, null, 8, ["modelValue"])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_48, [
                        (0, vue_2.createElementVNode)("div", _hoisted_49, [
                            (0, vue_2.createElementVNode)("div", _hoisted_50, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("first_mounting", "First mounting", "guarantee_product_return")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_51, [
                                (0, vue_2.createElementVNode)("div", _hoisted_52, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_53, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("first_mounting_no", "No", "guarantee_product_return")), 1),
                                    (0, vue_2.createVNode)(Toggle_vue_1.default, {
                                        modelValue: __props.guaranteeProductReturnCreateRequest.firstMounting,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((__props.guaranteeProductReturnCreateRequest.firstMounting) = $event)),
                                        class: "mx-3"
                                    }, null, 8, ["modelValue"]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_54, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("first_mounting_yes", "Yes", "guarantee_product_return")), 1)
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_55, [
                            (0, vue_2.createElementVNode)("div", _hoisted_56, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("main_use_area", "Main use area", "guarantee_product_return")), 1),
                            (0, vue_2.createVNode)(SelectInput_vue_1.default, {
                                "placeholder-enable": true,
                                placeholder: "",
                                "show-validity": true,
                                valid: __props.guaranteeProductReturnCreateRequest.isMainUseAreaValid((0, vue_2.unref)(vehicleTypeStore).selectedVehicleType),
                                "invalid-message": (0, vue_2.unref)(i18n_1.trans)('main_use_are_required', 'Main use are required', 'guarantee_product_return'),
                                class: "!flex-row items-center !w-fit !grow",
                                modelValue: __props.guaranteeProductReturnCreateRequest.mainUseArea,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((__props.guaranteeProductReturnCreateRequest.mainUseArea) = $event)),
                                modelModifiers: { number: true },
                                options: mainUseAreOptions.value
                            }, null, 8, ["valid", "invalid-message", "modelValue", "options"])
                        ])
                    ])
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
